import { IUser } from "./interfaces.tsx";
export const updateSta = (newState: IUser, setuser: (val: IUser) => void) => {
  setuser(newState);
  sessionStorage.setItem("cacheData", JSON.stringify(newState));
};

export const loadSta = (setuser: (val: IUser) => void) => {
  try {
    const storedState = sessionStorage.getItem("cacheData");
    if (storedState) {
      setuser(JSON.parse(storedState));
    }
  } catch (error) {
    console.error("Failed to load state from sessionStorage", error);
  }
};
export const deleteSta = (setuser: (val: IUser) => void) => {
  try {
    sessionStorage.removeItem("cacheData");
    setuser({});
  } catch (error) {
    console.error("Failed to delete state from sessionStorage", error);
  }
};

export const returnstate = () => {
  try {
    const storedState = sessionStorage.getItem("cacheData");
    if (storedState) {
      return JSON.parse(storedState);
    }
  } catch (error) {
    console.error("Failed to load state from sessionStorage", error);
  }
};
